@if (showContainer) {
  <div>
    <div>
      <img mat-dialog-close src="/assets/images/scan/close_icon.svg" alt="" class="close-btn" />
    </div>
    <section class="scan-input-for-mobile">
      <div class="scan-form-container">
        <div class="scan-form-container__title">Scan Shipping Label</div>
        <form [formGroup]="barcodeForm" (ngSubmit)="onSubmit()" class="scan-form" autocomplete="off">
          <mat-form-field appearance="outline">
            <mat-label>Insert barcode number</mat-label>
            <input class="barcode" #input matInput formControlName="barcode" />
          </mat-form-field>
          <button
            mat-button
            mat-flat-button
            color="primary"
            class="scan-form__submit"
            type="submit"
            [disabled]="barcodeForm.invalid || submitting">
            @if (!submitting) {
              OK
            }
            @if (submitting) {
              <mat-spinner [diameter]="20" class="barcode-spinner"></mat-spinner>
            }
          </button>
        </form>
      </div>
    </section>
  </div>
}

@if (!showContainer) {
  <section class="scan-input-container">
    <div class="scan-form-container">
      <div class="scan-form-container__title">
        Scan barcode now
        <img mat-dialog-close src="/assets/images/scan/close_icon.svg" alt="" class="close-btn-input" />
      </div>
      <form [formGroup]="barcodeForm" (ngSubmit)="onSubmit()" class="scan-form" autocomplete="off">
        <mat-form-field appearance="outline">
          <mat-label>Or enter order/barcode number</mat-label>
          <input class="barcode" #input matInput formControlName="barcode" />
        </mat-form-field>
        <button
          mat-button
          mat-flat-button
          color="primary"
          class="scan-form__submit"
          type="submit"
          [disabled]="barcodeForm.invalid || submitting">
          @if (!submitting) {
            OK
          }
          @if (submitting) {
            <mat-spinner [diameter]="20" class="barcode-spinner"></mat-spinner>
          }
        </button>
      </form>
    </div>
  </section>
}
